import { createRef, useEffect, useState } from 'react'
import ReactGA from 'react-ga4'

import { arrayBufferToBase64, isValidEmail } from '@/utils/helpers'

const MailForwarder = (): {
  desc: string
  email: string
  errors: Record<string, any>
  fileInput: React.RefObject<any>
  isPosting: boolean
  onCaptcha: () => void
  onChangeDesc: (e: React.ChangeEvent<HTMLInputElement>) => void
  onChangeEmail: (e: React.ChangeEvent<HTMLInputElement>) => void
  onFileChosen: (e: React.ChangeEvent<HTMLInputElement>) => void
  onSubmit: (s: string) => void
  success: string
} => {
  const fileInput = createRef()
  const [attachment, setAttachment] = useState<string>()
  const [attachmentName, setAttachmentName] = useState('')
  const [attachmentType, setAttachmentType] = useState('')
  const [desc, setDesc] = useState('')
  const [email, setEmail] = useState('')
  const [errors, setErrors] = useState<Record<string, any>>({})
  const [fileReader, setFileReader] = useState<FileReader>()
  const [isPosting, setIsPosting] = useState(false)
  const [notARobot, setNotARobot] = useState(false)
  const [success, setSuccess] = useState('')

  useEffect(() => {
    setFileReader(new window.FileReader())
  }, [])

  const onCaptcha = () => {
    const { ...otherErrors } = errors
    setErrors(otherErrors)
    setNotARobot(true)
  }

  const onChangeDesc = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { ...otherErrors } = errors
    setErrors(otherErrors)
    setDesc(e.target.value)
  }

  const onChangeEmail = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { ...otherErrors } = errors

    setErrors(otherErrors)
    setEmail(e.target.value)
  }

  const onFileChosen = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { ...otherErrors } = errors

    if (!e.target.files) {
      setAttachment(undefined)
      return setErrors(otherErrors)
    } else if (e.target.files[0].size > 50 * 1024 * 1024) {
      return setErrors({
        ...otherErrors,
        file: 'Screenshots must be smaller than 5 MB',
      })
    }

    if (!fileReader) return

    fileReader.onloadend = () => setAttachment(arrayBufferToBase64(fileReader.result as ArrayBuffer))
    fileReader.readAsArrayBuffer(e.target.files[0])

    setAttachmentName(e.target.files[0].name)
    setAttachmentType(e.target.files[0].type)
  }

  const onSubmit = async () => {
    let hasEmailConsent = true
    // @ts-ignore
    if (window.__tcfapi) {
      // @ts-ignore
      window.__tcfapi(
        'hasCustomConsent',
        2,
        (res: any) => {
          hasEmailConsent = res
        },
        'email',
      )
    }

    let gaClientId
    ReactGA.ga((tracker: any) => {
      gaClientId = tracker.get('clientId')
    })

    const { ...oldErrors } = errors

    const newErrors: Record<string, any> = {}
    if (!isValidEmail(email)) {
      newErrors['email'] = 'Plese enter a valid email address.'
    }
    if (desc === '') {
      newErrors['desc'] = 'Please enter description.'
    }
    if (!notARobot) {
      newErrors['captcha'] = 'Captcha failed.'
    }

    if (Object.keys(newErrors).length !== 0) {
      return setErrors({ ...oldErrors, ...newErrors })
    }

    const body: Record<string, any> = {
      attachment,
      attachmentName,
      attachmentType,
      desc,
      email,
      hasEmailConsent,
      to: 'edhrec@edhrec.com',
    }

    if (hasEmailConsent) {
      body.gaClientId = gaClientId
      body.history = history
    }

    setErrors({})
    setIsPosting(true)
    setSuccess('')

    let status
    try {
      const res = await fetch('https://glgcw6nmtk4k2m2orq7dlrtllu0deart.lambda-url.us-east-1.on.aws', {
        body: JSON.stringify(body),
        headers: { 'Content-Type': 'application/json' },
        method: 'POST',
      })
      status = res.status
      const json = await res.json()
      // eslint-disable-next-line no-prototype-builtins
      if (json.hasOwnProperty('errorMessage')) {
        setErrors({ submit: `Error: ${json.errorMessage}` })
        setIsPosting(false)
      }
    } catch (error: any) {
      if (status === 200) {
        setIsPosting(false)
        setSuccess('Message received, thanks!')
      } else {
        setErrors({ submit: `Error: ${error.message}` })
        setIsPosting(false)
      }
    }
  }

  return {
    desc,
    email,
    errors,
    fileInput,
    isPosting,
    onCaptcha,
    onChangeDesc,
    onChangeEmail,
    onFileChosen,
    onSubmit,
    success,
  }
}

export default MailForwarder
